import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './XlabsArchitecture.css';

/**
 * Architecture comparison — A: xlabs design · B: Construx /viewer
 * See docs/XLABS_ARCHITECTURE.md
 */

function XlabsDataflowSvg() {
  return (
    <svg viewBox="0 0 1200 460" xmlns="http://www.w3.org/2000/svg" fontFamily="Inter Tight, sans-serif">
      <defs>
        <marker id="arr-a" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto">
          <path d="M0,0 L10,5 L0,10 z" fill="#0a0a0a" />
        </marker>
        <marker id="arr-a-g" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto">
          <path d="M0,0 L10,5 L0,10 z" fill="#047857" />
        </marker>
      </defs>

      <g fontSize="10" fill="#a3a3a3" letterSpacing="1.2">
        <text x="20" y="40">UI</text>
        <text x="20" y="130">REDUX</text>
        <text x="20" y="220">DOMAIN</text>
        <text x="20" y="310">SPECKLE</text>
        <text x="20" y="400">RENDER</text>
      </g>
      <g stroke="#e5e5e5" strokeDasharray="2 4">
        <line x1="80" y1="60" x2="1180" y2="60" />
        <line x1="80" y1="150" x2="1180" y2="150" />
        <line x1="80" y1="240" x2="1180" y2="240" />
        <line x1="80" y1="330" x2="1180" y2="330" />
      </g>

      <g fontSize="12">
        <rect x="100" y="20" width="160" height="40" fill="#fff" stroke="#0a0a0a" />
        <text x="180" y="36" textAnchor="middle" fontWeight="600">Slider · width</text>
        <text x="180" y="51" textAnchor="middle" fill="#737373" fontSize="10">user drags 4.0 → 4.6m</text>

        <rect x="290" y="20" width="160" height="40" fill="#fffbeb" stroke="#b45309" />
        <text x="370" y="36" textAnchor="middle" fontWeight="600" fill="#b45309">SYNC · 142ms</text>
        <text x="370" y="51" textAnchor="middle" fill="#b45309" fontSize="10" opacity="0.8">latency indicator</text>

        <rect x="290" y="110" width="170" height="40" fill="#0a0a0a" />
        <text x="375" y="126" textAnchor="middle" fontWeight="600" fill="#fff">applyPatch()</text>
        <text x="375" y="141" textAnchor="middle" fill="#a3a3a3" fontSize="10" fontFamily="JetBrains Mono">replace /dimensions/width</text>

        <rect x="490" y="200" width="170" height="40" fill="#fff" stroke="#0a0a0a" />
        <text x="575" y="216" textAnchor="middle" fontWeight="600">invalidate()</text>
        <text x="575" y="231" textAnchor="middle" fill="#737373" fontSize="10">graph marks dirty nodes</text>

        <rect x="690" y="200" width="180" height="40" fill="#fff" stroke="#0a0a0a" />
        <text x="780" y="216" textAnchor="middle" fontWeight="600">generateDescriptors()</text>
        <text x="780" y="231" textAnchor="middle" fill="#737373" fontSize="10">pure fn(project) → meshes</text>

        <rect x="690" y="290" width="180" height="40" fill="#ecfdf5" stroke="#047857" />
        <text x="780" y="306" textAnchor="middle" fontWeight="600" fill="#047857">SpeckleAdapter.commit</text>
        <text x="780" y="321" textAnchor="middle" fill="#047857" fontSize="10" opacity="0.7">branches/main</text>

        <rect x="900" y="290" width="160" height="40" fill="#ecfdf5" stroke="#047857" />
        <text x="980" y="306" textAnchor="middle" fontWeight="600" fill="#047857">Speckle server</text>
        <text x="980" y="321" textAnchor="middle" fill="#047857" fontSize="10" opacity="0.7">graphql · ws subscribe</text>

        <rect x="900" y="380" width="160" height="40" fill="#ecfdf5" stroke="#047857" />
        <text x="980" y="396" textAnchor="middle" fontWeight="600" fill="#047857">@speckle/viewer</text>
        <text x="980" y="411" textAnchor="middle" fill="#047857" fontSize="10" opacity="0.7">load(commitObj)</text>

        <rect x="1090" y="20" width="90" height="40" fill="#fff" stroke="#0a0a0a" />
        <text x="1135" y="36" textAnchor="middle" fontWeight="600">readouts</text>
        <text x="1135" y="51" textAnchor="middle" fill="#737373" fontSize="10">cost · BOM</text>
      </g>

      <g fill="none" stroke="#0a0a0a" strokeWidth="1.2" markerEnd="url(#arr-a)">
        <path d="M180,60 L180,90 L290,130" />
        <path d="M375,150 L375,180 L575,200" />
        <path d="M660,220 L690,220" />
        <path d="M780,240 L780,290" />
        <path d="M780,330 L780,360 L900,400" />
      </g>
      <g fill="none" stroke="#047857" strokeWidth="1.2" markerEnd="url(#arr-a-g)" strokeDasharray="4 3">
        <path d="M870,310 L900,310" />
        <path d="M980,330 L980,380" />
        <path d="M1060,400 L1100,400 L1135,60" />
      </g>

      <g fontSize="9.5" fill="#a3a3a3" fontFamily="JetBrains Mono">
        <text x="220" y="84">~0ms</text>
        <text x="430" y="174">&lt;1ms</text>
        <text x="670" y="262">~30ms worker</text>
        <text x="870" y="282">~80ms ws</text>
        <text x="900" y="372">~30ms load</text>
      </g>
    </svg>
  );
}

function ConstruxDataflowSvg() {
  return (
    <svg viewBox="0 0 1200 520" xmlns="http://www.w3.org/2000/svg" fontFamily="Inter Tight, sans-serif">
      <defs>
        <marker id="arr-b" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto">
          <path d="M0,0 L10,5 L0,10 z" fill="#0a0a0a" />
        </marker>
        <marker id="arr-b-blue" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto">
          <path d="M0,0 L10,5 L0,10 z" fill="#1d4ed8" />
        </marker>
        <marker id="arr-b-g" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto">
          <path d="M0,0 L10,5 L0,10 z" fill="#047857" />
        </marker>
      </defs>

      <g fontSize="10" fill="#a3a3a3" letterSpacing="1.2">
        <text x="20" y="40">UI</text>
        <text x="20" y="120">STATE</text>
        <text x="20" y="200">ADAPTERS</text>
        <text x="20" y="290">RENDER</text>
        <text x="20" y="380">EXTERNALS</text>
        <text x="20" y="470">OPTIONAL</text>
      </g>
      <g stroke="#e5e5e5" strokeDasharray="2 4">
        <line x1="90" y1="55" x2="1180" y2="55" />
        <line x1="90" y1="135" x2="1180" y2="135" />
        <line x1="90" y1="215" x2="1180" y2="215" />
        <line x1="90" y1="305" x2="1180" y2="305" />
        <line x1="90" y1="395" x2="1180" y2="395" />
      </g>

      <g fontSize="12">
        <rect x="100" y="18" width="170" height="40" fill="#fff" stroke="#0a0a0a" />
        <text x="185" y="34" textAnchor="middle" fontWeight="600">Address · Load</text>
        <text x="185" y="49" textAnchor="middle" fill="#737373" fontSize="10">Places → geocode</text>

        <rect x="300" y="18" width="170" height="40" fill="#fffbeb" stroke="#b45309" />
        <text x="385" y="34" textAnchor="middle" fontWeight="600" fill="#b45309">SITE BOOT</text>
        <text x="385" y="49" textAnchor="middle" fill="#b45309" fontSize="10" opacity="0.8">tiles + floor lock</text>

        <rect x="100" y="100" width="180" height="40" fill="#0a0a0a" />
        <text x="190" y="116" textAnchor="middle" fontWeight="600" fill="#fff">setSite / setLot</text>
        <text x="190" y="131" textAnchor="middle" fill="#a3a3a3" fontSize="10" fontFamily="JetBrains Mono">SpeckleViewerPage</text>

        <rect x="320" y="180" width="160" height="40" fill="#fff" stroke="#0a0a0a" />
        <text x="400" y="196" textAnchor="middle" fontWeight="600">googleMapsSite</text>
        <text x="400" y="211" textAnchor="middle" fill="#737373" fontSize="10">geocode · elev · sat</text>

        <rect x="500" y="180" width="160" height="40" fill="#fff" stroke="#0a0a0a" />
        <text x="580" y="196" textAnchor="middle" fontWeight="600">photorealisticFloor</text>
        <text x="580" y="211" textAnchor="middle" fill="#737373" fontSize="10">raycast → floorY</text>

        <rect x="500" y="270" width="180" height="40" fill="#eff6ff" stroke="#1d4ed8" />
        <text x="590" y="286" textAnchor="middle" fontWeight="600" fill="#1d4ed8">SitePlannerViewer</text>
        <text x="590" y="301" textAnchor="middle" fill="#1d4ed8" fontSize="10" opacity="0.75">R3F · tiles · lot</text>

        <rect x="700" y="270" width="170" height="40" fill="#eff6ff" stroke="#1d4ed8" />
        <text x="785" y="286" textAnchor="middle" fontWeight="600" fill="#1d4ed8">AduInstance</text>
        <text x="785" y="301" textAnchor="middle" fill="#1d4ed8" fontSize="10" opacity="0.75">useGLTF · /models</text>

        <rect x="320" y="360" width="160" height="40" fill="#fff" stroke="#0a0a0a" />
        <text x="400" y="376" textAnchor="middle" fontWeight="600">Google APIs</text>
        <text x="400" y="391" textAnchor="middle" fill="#737373" fontSize="10">Maps · Tiles · Elev</text>

        <rect x="700" y="360" width="170" height="40" fill="#fff" stroke="#0a0a0a" />
        <text x="785" y="376" textAnchor="middle" fontWeight="600">static GLBs</text>
        <text x="785" y="391" textAnchor="middle" fill="#737373" fontSize="10">SoftPlan → OBJ → GLB</text>

        <rect x="900" y="18" width="160" height="40" fill="#fff" stroke="#0a0a0a" />
        <text x="980" y="34" textAnchor="middle" fontWeight="600">Place · Add ADU</text>
        <text x="980" y="49" textAnchor="middle" fill="#737373" fontSize="10">catalog · gizmo</text>

        <rect x="900" y="100" width="160" height="40" fill="#0a0a0a" />
        <text x="980" y="116" textAnchor="middle" fontWeight="600" fill="#fff">setStructures</text>
        <text x="980" y="131" textAnchor="middle" fill="#a3a3a3" fontSize="10" fontFamily="JetBrains Mono">page useState</text>

        <rect x="900" y="450" width="180" height="40" fill="#ecfdf5" stroke="#047857" />
        <text x="990" y="466" textAnchor="middle" fontWeight="600" fill="#047857">speckleLiveSync</text>
        <text x="990" y="481" textAnchor="middle" fill="#047857" fontSize="10" opacity="0.7">debounce → version</text>

        <rect x="1100" y="450" width="80" height="40" fill="#ecfdf5" stroke="#047857" />
        <text x="1140" y="466" textAnchor="middle" fontWeight="600" fill="#047857">Speckle</text>
        <text x="1140" y="481" textAnchor="middle" fill="#047857" fontSize="10" opacity="0.7">GraphQL</text>
      </g>

      <g fill="none" stroke="#0a0a0a" strokeWidth="1.2" markerEnd="url(#arr-b)">
        <path d="M185,58 L185,100" />
        <path d="M190,140 L190,160 L400,180" />
        <path d="M480,200 L500,200" />
        <path d="M400,220 L400,360" />
        <path d="M980,58 L980,100" />
      </g>
      <g fill="none" stroke="#1d4ed8" strokeWidth="1.2" markerEnd="url(#arr-b-blue)">
        <path d="M580,220 L580,270" />
        <path d="M680,290 L700,290" />
        <path d="M785,310 L785,360" />
        <path d="M980,140 L980,200 L785,270" />
      </g>
      <g fill="none" stroke="#047857" strokeWidth="1.2" markerEnd="url(#arr-b-g)" strokeDasharray="4 3">
        <path d="M980,140 L980,450" />
        <path d="M1080,470 L1100,470" />
      </g>

      <g fontSize="9.5" fill="#a3a3a3" fontFamily="JetBrains Mono">
        <text x="200" y="84">~0ms</text>
        <text x="250" y="168">network</text>
        <text x="500" y="258">floor lock</text>
        <text x="860" y="258">GLB load</text>
        <text x="1020" y="430">~500ms debounce</text>
      </g>
    </svg>
  );
}

function ArchBanner({ id, letter, title, sub, tag, variant }) {
  return (
    <div className={`arch-banner ${variant || ''}`} id={id}>
      <div className="letter">{letter}</div>
      <div>
        <h3>{title}</h3>
        <p>{sub}</p>
      </div>
      <span className="tag">{tag}</span>
    </div>
  );
}

export default function XlabsArchitecture() {
  return (
    <div className="xlabs-arch">
      <Helmet>
        <title>xlabs · architecture comparison</title>
        <meta
          name="description"
          content="Compare xlabs Speckle-first configurator architecture with Construx /viewer (R3F site planner)."
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter+Tight:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <div className="page">
        <header className="doc-head">
          <div className="doc-mark" aria-hidden="true" />
          <div>
            <div className="doc-title">xlabs · architecture comparison</div>
            <div className="doc-sub">
              Side-by-side: the Speckle-first xlabs design target vs how Construx <span className="mono">/viewer</span> works today.
            </div>
          </div>
          <div className="doc-meta">
            <b>v0.2 · compare</b>
            Jul 18 2026 · /xlabs
          </div>
        </header>

        <section>
          <h2>
            <span className="num">00</span> Delta at a glance
          </h2>
          <p>
            Same visual language on both halves. The structural fork:{' '}
            <strong>A routes every edit through Speckle commits</strong>; <strong>B keeps scene truth in page state and renders with R3F</strong>, using Speckle only as stream mode or optional outbound sync.
          </p>
          <table className="delta">
            <thead>
              <tr>
                <th>Axis</th>
                <th>A · xlabs design</th>
                <th>B · Construx /viewer</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="axis">framework</td>
                <td className="a">Next.js App Router</td>
                <td className="b">CRA React 18 · react-router</td>
              </tr>
              <tr>
                <td className="axis">state</td>
                <td className="a">Redux Toolkit slices</td>
                <td className="b">page useState on SpeckleViewerPage</td>
              </tr>
              <tr>
                <td className="axis">speckle</td>
                <td className="a">Commit backbone (patch → commit → viewer)</td>
                <td className="b">Optional: stream mode or live sync out</td>
              </tr>
              <tr>
                <td className="axis">render</td>
                <td className="a">@speckle/viewer + R3F overlays</td>
                <td className="b">R3F SitePlannerViewer + tiles + GLB</td>
              </tr>
              <tr>
                <td className="axis">journey</td>
                <td className="a">Locate → Design → Analyse → Build</td>
                <td className="b">Site → Place → Inspect → Next</td>
              </tr>
              <tr>
                <td className="axis">assets</td>
                <td className="a">Descriptors → Speckle objects</td>
                <td className="b">SoftPlan → GLB offline · Google tiles</td>
              </tr>
            </tbody>
          </table>
          <div className="jump">
            <a href="#arch-a">Jump to A · xlabs →</a>
            <a href="#arch-b">Jump to B · Construx →</a>
            <Link to="/xlabs-compare">Side-by-side compare →</Link>
            <Link to="/xlabs/speckle-case">Speckle $99 business case →</Link>
          </div>
        </section>

        {/* ═══════════════ A · xlabs design ═══════════════ */}
        <ArchBanner
          id="arch-a"
          letter="A"
          title="xlabs · Speckle configurator architecture"
          sub="Realtime parametric AEC configurator — Next.js, Redux, Three.js / drei, Speckle viewer SDK."
          tag="design target"
        />

        <section>
          <h2>
            <span className="num">A1</span> Premise
          </h2>
          <div className="two-col">
            <div>
              <p>
                <strong>The 3D model is not editable.</strong> It is a renderable projection of canonical project state. Every visible mesh derives from typed state, computed constraints, and deterministic geometry generators.
              </p>
              <p>
                Speckle sits between configuration state and the renderer. State changes produce a <span className="mono">commit</span> on a stream; the Speckle viewer subscribes and renders. The user sees{' '}
                <strong>realtime feedback</strong> — sliders move, geometry updates ~150ms later with a latency indicator.
              </p>
            </div>
            <div>
              <p>
                <strong>Why route through Speckle</strong> rather than rendering directly? Versioning, multi-client sync, comments, and a federated AEC data graph. The trade-off is round-trip latency — which the UI must make legible.
              </p>
              <p>
                The configurator UI never speaks <span className="mono">@speckle/objects</span>. A <strong>Speckle adapter</strong> translates project patches to commits and viewer events back to selection state.
              </p>
            </div>
          </div>
        </section>

        <section>
          <h2>
            <span className="num">A2</span> Layered architecture
          </h2>
          <div className="diagram">
            <div className="diagram-title">
              <span>System layers · xlabs</span>
              <span className="mono">L0 → L5</span>
            </div>
            <div className="layer-stack">
              <div className="layer">
                <div className="layer-label">
                  <b>L0 · UI</b>
                  Next.js · App Router
                </div>
                <div className="layer-row">
                  <div className="node">
                    <b>ConfiguratorShell</b>
                    <small>app/(configure)/page</small>
                  </div>
                  <div className="node">
                    <b>LocateStep</b>
                    <small>map · polygon</small>
                  </div>
                  <div className="node">
                    <b>DesignStep</b>
                    <small>viewer · panels</small>
                  </div>
                  <div className="node">
                    <b>AnalyseStep</b>
                    <small>cost · carbon</small>
                  </div>
                  <div className="node">
                    <b>BuildStep</b>
                    <small>BOM · export</small>
                  </div>
                </div>
              </div>
              <div className="layer">
                <div className="layer-label">
                  <b>L1 · State</b>
                  Redux Toolkit
                </div>
                <div className="layer-row">
                  <div className="node solid">
                    <b>projectSlice</b>
                    <small>canonical truth</small>
                  </div>
                  <div className="node">
                    <b>uiSlice</b>
                    <small>tool · selection</small>
                  </div>
                  <div className="node">
                    <b>derivedSlice</b>
                    <small>worker outputs</small>
                  </div>
                  <div className="node">
                    <b>historySlice</b>
                    <small>patch undo/redo</small>
                  </div>
                  <div className="node">
                    <b>speckleSlice</b>
                    <small>stream · commits</small>
                  </div>
                </div>
              </div>
              <div className="layer">
                <div className="layer-label">
                  <b>L2 · Domain</b>
                  pure TS
                </div>
                <div className="layer-row">
                  <div className="node">
                    <b>geometry/*</b>
                    <small>descriptor generators</small>
                  </div>
                  <div className="node">
                    <b>constraints/*</b>
                    <small>graph · solver</small>
                  </div>
                  <div className="node">
                    <b>bom/*</b>
                    <small>takeoff · nesting</small>
                  </div>
                  <div className="node">
                    <b>pricing/*</b>
                    <small>estimators</small>
                  </div>
                </div>
              </div>
              <div className="layer">
                <div className="layer-label">
                  <b>L3 · Adapters</b>
                  I/O boundary
                </div>
                <div className="layer-row">
                  <div className="node speckle">
                    <b>SpeckleAdapter</b>
                    <small>patch ↔ commit</small>
                  </div>
                  <div className="node">
                    <b>WorkerProxy</b>
                    <small>solver · BOM</small>
                  </div>
                  <div className="node">
                    <b>PersistenceAdapter</b>
                    <small>/api/projects</small>
                  </div>
                  <div className="node">
                    <b>ExportAdapter</b>
                    <small>jobs · signed URLs</small>
                  </div>
                </div>
              </div>
              <div className="layer">
                <div className="layer-label">
                  <b>L4 · Render</b>
                  Three.js
                </div>
                <div className="layer-row">
                  <div className="node speckle">
                    <b>SpeckleViewer</b>
                    <small>@speckle/viewer</small>
                  </div>
                  <div className="node">
                    <b>R3F overlay</b>
                    <small>dimensions · ghosts</small>
                  </div>
                  <div className="node">
                    <b>OrbitControls</b>
                    <small>drei</small>
                  </div>
                  <div className="node dashed">
                    <b>SelectionBus</b>
                    <small>viewer ↔ store</small>
                  </div>
                </div>
              </div>
              <div className="layer">
                <div className="layer-label">
                  <b>L5 · Backend</b>
                  Speckle server
                </div>
                <div className="layer-row">
                  <div className="node speckle">
                    <b>Stream</b>
                    <small>project graph</small>
                  </div>
                  <div className="node speckle">
                    <b>Branches</b>
                    <small>main · variants</small>
                  </div>
                  <div className="node speckle">
                    <b>Commits</b>
                    <small>versioned states</small>
                  </div>
                  <div className="node speckle">
                    <b>Subscriptions</b>
                    <small>graphql ws</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <h2>
            <span className="num">A3</span> Realtime dataflow
          </h2>
          <p>
            End-to-end for a single dimension change. Slider → SYNC indicator → viewer update. Target: under 250ms on a warm cache. Speckle is on the critical path (green).
          </p>
          <div className="flow-wrap">
            <XlabsDataflowSvg />
          </div>
        </section>

        <section>
          <h2>
            <span className="num">A4</span> Speckle adapter contract
          </h2>
          <div className="two-col">
            <div>
              <p>
                The adapter is the only module that imports <span className="mono">@speckle/viewer</span> and <span className="mono">@speckle/objects</span>. Everything else speaks domain types — Speckle stays swappable.
              </p>
              <p>
                Patches accumulate in a debounce buffer (<span className="mono">120ms</span>) and ship as a single Speckle commit. A slider drag collapses to one commit, not forty.
              </p>
            </div>
            <div>
              <table className="contract">
                <thead>
                  <tr>
                    <th>Surface</th>
                    <th>Direction</th>
                    <th>Payload</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="k">connect(streamId)</td>
                    <td>↗</td>
                    <td className="t">init viewer + ws subscription</td>
                  </tr>
                  <tr>
                    <td className="k">commitPatch(patches)</td>
                    <td>↗</td>
                    <td className="t">debounced patches → 1 commit</td>
                  </tr>
                  <tr>
                    <td className="k">loadCommit(id)</td>
                    <td>↗</td>
                    <td className="t">viewer.loadObject(refId)</td>
                  </tr>
                  <tr>
                    <td className="k">onCommitCreated</td>
                    <td>↘</td>
                    <td className="t">remote collaborator update</td>
                  </tr>
                  <tr>
                    <td className="k">onSelectionChanged</td>
                    <td>↘</td>
                    <td className="t">viewer hit → uiSlice.selectedIds</td>
                  </tr>
                  <tr>
                    <td className="k">onLatency</td>
                    <td>↘</td>
                    <td className="t">round-trip ms → SYNC badge</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

        <section>
          <h2>
            <span className="num">A5</span> Step model · Locate → Build
          </h2>
          <p>
            Each step is a route under <span className="mono">/configure/[projectId]</span>. The viewer persists across steps — only overlays and panels swap.
          </p>
          <ol className="steps">
            <li>
              <b>01 · Locate</b>
              Mapbox 2D site polygon. Output: <span className="mono">site.polygon</span>, <span className="mono">site.orientationDeg</span>. Setbacks from local zoning rules.
            </li>
            <li>
              <b>02 · Design</b>
              3D viewer + parametric controls. Speckle stream created on first commit; every subsequent patch becomes a commit on <span className="mono">main</span>.
            </li>
            <li>
              <b>03 · Analyse</b>
              Same scene — colour-coded cost / carbon / span overlays. Read-only; edits return to Design.
            </li>
            <li>
              <b>04 · Build</b>
              Panelization preview, BOM, export jobs (JSON, GLTF, CSV, PDF, CNC SVG, zip).
            </li>
          </ol>
        </section>

        <section>
          <h2>
            <span className="num">A6</span> Directory plan
          </h2>
          <div className="three-col">
            <div className="specsheet">
              <h3>app/</h3>
              <dl className="spec">
                <dt>(configure)/[id]/page.tsx</dt>
                <dd>Shell + step router</dd>
                <dt>locate/</dt>
                <dd>Mapbox polygon UI</dd>
                <dt>design/</dt>
                <dd>Viewer + panels</dd>
                <dt>analyse/</dt>
                <dd>Overlays only</dd>
                <dt>build/</dt>
                <dd>BOM + exports</dd>
                <dt>api/projects/</dt>
                <dd>CRUD + patch</dd>
              </dl>
            </div>
            <div className="specsheet">
              <h3>components/</h3>
              <dl className="spec">
                <dt>canvas/Viewer.tsx</dt>
                <dd>Speckle viewer host</dd>
                <dt>canvas/Overlays.tsx</dt>
                <dd>R3F dimensions</dd>
                <dt>panels/BuildStack.tsx</dt>
                <dd>Project tree</dd>
                <dt>panels/Metrics.tsx</dt>
                <dd>Cost · carbon</dd>
                <dt>panels/Inspector.tsx</dt>
                <dd>Selected props</dd>
                <dt>chrome/StepNav.tsx</dt>
                <dd>Locate → Build</dd>
              </dl>
            </div>
            <div className="specsheet">
              <h3>lib/</h3>
              <dl className="spec">
                <dt>store/</dt>
                <dd>RTK slices · selectors</dd>
                <dt>geometry/</dt>
                <dd>Pure descriptor fns</dd>
                <dt>constraints/</dt>
                <dd>Graph · solver</dd>
                <dt>bom/</dt>
                <dd>Takeoff · nesting</dd>
                <dt>speckle/adapter.ts</dt>
                <dd>Patch ↔ commit</dd>
                <dt>workers/</dt>
                <dd>solver · bom · export</dd>
              </dl>
            </div>
          </div>
        </section>

        {/* ═══════════════ B · Construx ═══════════════ */}
        <ArchBanner
          id="arch-b"
          letter="B"
          variant="b"
          title="Construx · /viewer architecture"
          sub="Site planner on CRA React + R3F / drei / Three.js — Speckle as stream mode or optional outbound live sync."
          tag="as built"
        />

        <section>
          <h2>
            <span className="num">B1</span> Premise
          </h2>
          <div className="two-col">
            <div>
              <p>
                <strong>The 3D scene is not Speckle-authored at edit time.</strong> Canonical truth lives in{' '}
                <span className="mono">SpeckleViewerPage</span> React state — site, lot, structures, floor lock, layers, stage. The R3F canvas is a controlled projection of that state.
              </p>
              <p>
                SoftPlan / catalog meshes arrive as static <span className="mono">/models/*.glb</span> (offline convert). Photorealistic context comes from Google Map Tiles. Journey:{' '}
                <strong>Site → Place → Inspect → Next</strong>.
              </p>
            </div>
            <div>
              <p>
                <strong>Where Speckle fits:</strong> (1) <span className="mono">?mode=speckle</span> loads a hosted stream with{' '}
                <span className="mono">@speckle/viewer</span>; (2) internal live sync can push lot + ADU meshes as Speckle versions via{' '}
                <span className="mono">@speckle/objectsender</span>. Neither is required to place an ADU.
              </p>
              <p>
                Unlike A, Construx keeps Speckle <strong>swappable and optional</strong> — the planner runs without a Speckle network round-trip on the edit path.
              </p>
            </div>
          </div>
        </section>

        <section>
          <h2>
            <span className="num">B2</span> Layered architecture
          </h2>
          <div className="diagram">
            <div className="diagram-title">
              <span>System layers · Construx</span>
              <span className="mono">L0 → L5</span>
            </div>
            <div className="layer-stack">
              <div className="layer">
                <div className="layer-label">
                  <b>L0 · UI</b>
                  CRA · react-router
                </div>
                <div className="layer-row">
                  <div className="node">
                    <b>SpeckleViewerPage</b>
                    <small>/viewer · modes</small>
                  </div>
                  <div className="node">
                    <b>ViewerChrome</b>
                    <small>stages · rail · FAB</small>
                  </div>
                  <div className="node">
                    <b>SitePlannerPanel</b>
                    <small>stage sheet</small>
                  </div>
                  <div className="node dashed">
                    <b>mode tabs</b>
                    <small>site · model · speckle</small>
                  </div>
                </div>
              </div>
              <div className="layer">
                <div className="layer-label">
                  <b>L1 · State</b>
                  page useState
                </div>
                <div className="layer-row">
                  <div className="node solid">
                    <b>site · lot · structures</b>
                    <small>canonical truth</small>
                  </div>
                  <div className="node">
                    <b>floorY · layers</b>
                    <small>lock · clip</small>
                  </div>
                  <div className="node">
                    <b>plannerStage</b>
                    <small>Site→Next</small>
                  </div>
                  <div className="node">
                    <b>liveSync*</b>
                    <small>debounce scheduler</small>
                  </div>
                </div>
              </div>
              <div className="layer">
                <div className="layer-label">
                  <b>L2 · Domain</b>
                  data · catalog
                </div>
                <div className="layer-row">
                  <div className="node">
                    <b>sitePlannerCatalog</b>
                    <small>Construx SKUs</small>
                  </div>
                  <div className="node">
                    <b>softplanExamples</b>
                    <small>sp-* catalog</small>
                  </div>
                  <div className="node">
                    <b>r1asRoomLabels</b>
                    <small>mesh name map</small>
                  </div>
                </div>
              </div>
              <div className="layer">
                <div className="layer-label">
                  <b>L3 · Adapters</b>
                  I/O boundary
                </div>
                <div className="layer-row">
                  <div className="node">
                    <b>googleMapsSite</b>
                    <small>geocode · Places</small>
                  </div>
                  <div className="node">
                    <b>osmBuildings</b>
                    <small>Overpass extrude</small>
                  </div>
                  <div className="node">
                    <b>photorealisticFloor</b>
                    <small>raycast lock</small>
                  </div>
                  <div className="node speckle">
                    <b>speckleLiveSync</b>
                    <small>graph → version</small>
                  </div>
                  <div className="node dashed">
                    <b>softplan-web3d</b>
                    <small>offline convert</small>
                  </div>
                </div>
              </div>
              <div className="layer">
                <div className="layer-label">
                  <b>L4 · Render</b>
                  Three.js
                </div>
                <div className="layer-row">
                  <div className="node r3f">
                    <b>SitePlannerViewer</b>
                    <small>@react-three/fiber</small>
                  </div>
                  <div className="node r3f">
                    <b>PhotorealisticTiles</b>
                    <small>3d-tiles-renderer</small>
                  </div>
                  <div className="node r3f">
                    <b>AduInstance</b>
                    <small>useGLTF · gizmo</small>
                  </div>
                  <div className="node speckle">
                    <b>Viewer.js</b>
                    <small>@speckle/viewer</small>
                  </div>
                </div>
              </div>
              <div className="layer">
                <div className="layer-label">
                  <b>L5 · Externals</b>
                  third party
                </div>
                <div className="layer-row">
                  <div className="node">
                    <b>Google Maps</b>
                    <small>geocode · tiles · elev</small>
                  </div>
                  <div className="node speckle">
                    <b>Speckle server</b>
                    <small>stream · versions</small>
                  </div>
                  <div className="node">
                    <b>/models/*.glb</b>
                    <small>static assets</small>
                  </div>
                  <div className="node dashed">
                    <b>SoftPlan Web3D</b>
                    <small>source .dat</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <h2>
            <span className="num">B3</span> Product dataflow
          </h2>
          <p>
            Load a site and place an ADU. Speckle live sync (green, dashed) is optional — the solid path is page state → R3F only.
          </p>
          <div className="flow-wrap">
            <ConstruxDataflowSvg />
          </div>
        </section>

        <section>
          <h2>
            <span className="num">B4</span> Speckle surface contract
          </h2>
          <div className="two-col">
            <div>
              <p>
                Only <span className="mono">Viewer.js</span> and <span className="mono">speckleLiveSync.js</span> speak Speckle SDKs. The site planner never imports{' '}
                <span className="mono">@speckle/viewer</span> into the R3F canvas.
              </p>
              <p>
                Live sync debounces (~500ms), bakes world-space meshes, converts Three Y-up → Speckle Z-up{' '}
                <span className="mono">(x,y,z)→(x,−z,y)</span>, then <span className="mono">send</span> + GraphQL create version.
              </p>
            </div>
            <div>
              <table className="contract">
                <thead>
                  <tr>
                    <th>Surface</th>
                    <th>Direction</th>
                    <th>Payload</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="k">loadObject(url)</td>
                    <td>↗</td>
                    <td className="t">stream mode · SpeckleLoader</td>
                  </tr>
                  <tr>
                    <td className="k">pushLiveVersion</td>
                    <td>↗</td>
                    <td className="t">lot + ADUs (+ tiles) → version</td>
                  </tr>
                  <tr>
                    <td className="k">createLiveSyncScheduler</td>
                    <td>↔</td>
                    <td className="t">debounce edits → push</td>
                  </tr>
                  <tr>
                    <td className="k">Section / Measure</td>
                    <td>↘</td>
                    <td className="t">viewer extensions (stream mode)</td>
                  </tr>
                  <tr>
                    <td className="k">version URL</td>
                    <td>↘</td>
                    <td className="t">panel · Open Speckle</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

        <section>
          <h2>
            <span className="num">B5</span> Step model · Site → Next
          </h2>
          <p>
            Stages under <span className="mono">ViewerChrome</span> on <span className="mono">/viewer</span>. R3F persists across stages. Power modes:{' '}
            <span className="mono">?mode=model</span>, <span className="mono">?mode=speckle</span>.
          </p>
          <ol className="steps">
            <li>
              <b>01 · Site</b>
              Address → Load → Photorealistic tiles + floor lock. Output: <span className="mono">site</span>, <span className="mono">lot</span>,{' '}
              <span className="mono">floorY</span>.
            </li>
            <li>
              <b>02 · Place</b>
              Catalog + FAB Add ADU. PivotControls; meshes from <span className="mono">/models/&lt;slug&gt;.glb</span>.
            </li>
            <li>
              <b>03 · Inspect</b>
              Roof / walls / interior layers + vertical section clip.
            </li>
            <li>
              <b>04 · Next</b>
              Handoff CTA. Speckle sync behind Tools / Sync rail.
            </li>
          </ol>
        </section>

        <section>
          <h2>
            <span className="num">B6</span> Directory plan
          </h2>
          <div className="three-col">
            <div className="specsheet">
              <h3>src/components/</h3>
              <dl className="spec">
                <dt>Pages/SpeckleViewerPage</dt>
                <dd>State + mode shell</dd>
                <dt>Viewer/ViewerChrome</dt>
                <dd>Stages · rail · boot</dd>
                <dt>Viewer/SitePlannerPanel</dt>
                <dd>Stage sheet</dd>
                <dt>Viewer/SitePlannerViewer</dt>
                <dd>R3F scene</dd>
                <dt>Viewer/Viewer.js</dt>
                <dd>Speckle island</dd>
                <dt>Viewer/R3FModelViewer</dt>
                <dd>Model-only mode</dd>
              </dl>
            </div>
            <div className="specsheet">
              <h3>src/services/</h3>
              <dl className="spec">
                <dt>googleMapsSite.js</dt>
                <dd>Geocode · Places · elev</dd>
                <dt>osmBuildings.js</dt>
                <dd>Context footprints</dd>
                <dt>photorealisticFloor.js</dt>
                <dd>Floor raycast lock</dd>
                <dt>speckleLiveSync.js</dt>
                <dd>Outbound versions</dd>
                <dt>catalogModelPreload.js</dt>
                <dd>useGLTF.preload</dd>
              </dl>
            </div>
            <div className="specsheet">
              <h3>assets · tools · docs</h3>
              <dl className="spec">
                <dt>public/models/</dt>
                <dd>Runtime GLBs</dd>
                <dt>tools/softplan-web3d/</dt>
                <dd>.dat → OBJ → GLB</dd>
                <dt>data/sitePlannerCatalog</dt>
                <dd>SKU map</dd>
                <dt>docs/ADU_SITE_PLANNER</dt>
                <dd>Planner SoT</dd>
                <dt>docs/VIEWER_UX_BRIEF</dt>
                <dd>Chrome target</dd>
              </dl>
            </div>
          </div>
        </section>

        <div className="next">
          <div>
            <h3>Next: open Construx /viewer</h3>
            <p>Exercise the as-built path (B). Speckle stream and live sync remain available from Tools.</p>
          </div>
          <Link className="cta" to="/viewer">
            Open /viewer →
          </Link>
        </div>
      </div>
    </div>
  );
}
